import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { about, education } from '../data/mock';

const About = () => {
  return (
    <section
      id="about"
      className="py-20 md:py-24 px-6 border-b border-stone-400/25 dark:border-stone-500/20 bg-white/[0.22] dark:bg-stone-950/30"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12">
          <div className="space-y-6">
            <div>
              <h2 className="text-4xl font-bold text-stone-900 dark:text-stone-100 mb-4 leading-tight">
                About Me
              </h2>
              <div className="w-16 h-1 bg-amber-800 dark:bg-amber-600 rounded-full"></div>
            </div>

            <p className="text-base text-stone-600 dark:text-stone-300 leading-relaxed">
              {about.summary}
            </p>

            <div className="space-y-3">
              {about.highlights.map((highlight, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <CheckCircle2 className="w-5 h-5 text-amber-800 dark:text-amber-600 flex-shrink-0 mt-0.5" />
                  <p className="text-sm text-stone-600 dark:text-stone-300">{highlight}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-5">
            <div className="p-6 rounded-2xl bg-white/60 dark:bg-stone-800/60 backdrop-blur-md border border-stone-200/50 dark:border-stone-700/50 shadow-lg">
              <h3 className="text-xl font-bold text-stone-900 dark:text-stone-100 mb-5">
                Education
              </h3>
              <div className="space-y-5">
                {education.map((edu, index) => (
                  <div key={edu.id}>
                    <div className="space-y-2">
                      <div>
                        <h4 className="text-base font-semibold text-stone-900 dark:text-stone-100">
                          {edu.degree}
                        </h4>
                        <p className="text-sm text-amber-800 dark:text-amber-600 font-medium">{edu.field}</p>
                      </div>
                      <p className="text-sm text-stone-600 dark:text-stone-300">
                        {edu.institution}
                      </p>
                      <div className="flex justify-between items-center pt-1">
                        <span className="text-xs text-stone-500 dark:text-stone-400">
                          {edu.duration}
                        </span>
                        <span className="px-3 py-1 bg-amber-100 dark:bg-amber-900/30 text-amber-900 dark:text-amber-200 rounded-full text-xs font-medium">
                          {edu.grade}
                        </span>
                      </div>
                    </div>
                    {index < education.length - 1 && (
                      <div className="mt-4 border-b border-stone-200 dark:border-stone-700"></div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
